import { Component, OnInit } from '@angular/core';
import { WebPage } from '../../shared/web-page';
import { MessageService } from 'primeng/components/common/messageservice';
import { Router, ActivatedRoute } from '@angular/router';
import { ArquivoService } from '../../shared/services/arquivo.service';
import { ConfirmationService } from 'primeng/primeng';
import {
  AbstractControl,
  FormArray,
  Validators,
  FormGroup,
  FormBuilder
} from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { DocumentoAssinadoService } from '../../shared/services/documento-assinado.service';
import { EnumTipoArquivo } from '../../../models/tipoArquivo';
import { CandidatoService } from '../candidato.service';
import { CandidatoAprovadoService } from '../../../services/candidato-aprovado.service';

@Component({
  selector: 'emprego-na-pista-analisar-documentos-candidato',
  templateUrl: './analisar-documentos-candidato.component.html',
  styleUrls: ['./analisar-documentos-candidato.component.css']
})
export class AnalisarDocumentosCandidatoComponent extends WebPage
implements OnInit {
form: FormGroup;
idCandidato;
tipoArquivo;
idTipoArquivo;
tipoAnalise;
idTipoAnalise;
documentosAssinados;
isNotPermitirSalvar = true;
isPermitirGerarTermo;
acaoSalvar = 'Salvar';

get arquivos() {
  return this.form.get('arquivos') as FormArray;
}

constructor(
  messageService: MessageService,
  private _router: Router,
  private route: ActivatedRoute,
  private fb: FormBuilder,
  private arquivoService: ArquivoService,
  private confirmationService: ConfirmationService,
  private documentoService: DocumentoAssinadoService,
  private candidatoService: CandidatoService,
  private candidatoAprovadoService: CandidatoAprovadoService,
) {
  super(messageService);

  this.route.paramMap.subscribe(params => {
    this.idCandidato = params.get('idCandidato');

    this.form = this.fb.group({
      idCandidato: [this.idCandidato],
      arquivos: new FormArray([])
    });
  });
}

ngOnInit() {
  this.getTipoArquivo();
  this.getTipoAnalise();
  this.getDocumentos();
}

myUploader(event, fileUpload): void {
  console.log('My File upload', event);

  if (this.idTipoArquivo === undefined) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Atenção',
      detail: 'Selecione um tipo!'
    });
    fileUpload.clear();
    return;
  }

  if (event.files.length === 0) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Atenção',
      detail: 'Arquivo não inserido!'
    });
    fileUpload.clear();
    return;
  }

  const fileToUpload = event.files[0];
  const input = new FormData();
  input.append('arquivo', fileToUpload);
  input.append('idCandidato', this.idCandidato);
  input.append('idTipoArquivo', this.idTipoArquivo);

  this.arquivoService
    .upload(input)
    .finally(() => (this.isLoading = false))
    .subscribe(
      res => {
        this.getTipoArquivo();
        this.getDocumentos();
        fileUpload.clear();
      },
      error => {
        fileUpload.clear();
        this.gerenciaErro(error);
      }
    );
}

getDocumentos() {
  this.documentoService
    .getByIdCadidato(this.idCandidato)
    .finally(() => (this.isLoading = false))
    .subscribe(
      documentosAssinados => {
        this.documentosAssinados = documentosAssinados;
        console.log(documentosAssinados);
      },
      error => this.gerenciaErro(error)
    );
}

selectOption(value) {
  this.idTipoArquivo = value;
}
selectOptionAnalise(value) {
  this.idTipoAnalise = value;
  switch (this.idTipoAnalise){
    case 'aa13c5d4-b0b4-4c28-aef9-29aca154e059': //Em Analise
      this.isNotPermitirSalvar = true;
      this.acaoSalvar = 'Salvar';
      break;
    case 'e91f1439-b00f-4149-95d8-af00a5d52c32': //Aprovado
      this.isNotPermitirSalvar = false;
      this.acaoSalvar = 'Salvar e Gerar Termo';
      break;
    case 'd7981bec-c4f4-4e11-85e0-eb7338d5cd2d': //Reprovado
      this.isNotPermitirSalvar = false;
      this.acaoSalvar = 'Salvar';
      break;
    default:
      break;
  }
}
downloadArquivo(idArquivo, nomeArquivo) {
  console.log(idArquivo);
  console.log(nomeArquivo);
  this.arquivoService.downloadArquivo(idArquivo, nomeArquivo);
}

removeArquivosDoBanco(idArquivo: string) {
  // console.log(event);
  // console.log(event.path[1].hidden);
  // event.path[1].hidden = true;
  // console.log(event.path[1].hidden);

  this.confirmationService.confirm({
    message: 'Tem certeza que deseja excluir?',
    header: 'Confirmação',
    icon: 'fa fa-question-circle',
    accept: () => {
      this.arquivoService
        .removeArquivo(idArquivo)
        .finally(() => (this.isLoading = false))
        .subscribe(
          () => {
            this.getTipoArquivo();
            this.getDocumentos();
          },
          error => this.gerenciaErro(error)
        );
    }
  });
}

podeExcluirArquivo(idTipoArquivo:string){
  idTipoArquivo = idTipoArquivo.toUpperCase();
  if(EnumTipoArquivo.NotaTecnicaTermoAditivo === idTipoArquivo || EnumTipoArquivo.TermoAditivoAssinado === idTipoArquivo){
    return false;
  }
  else{
    return true;
  }

}
salvar(){
  var statusAnalise = this.idTipoAnalise;
  switch (statusAnalise){
    case 'aa13c5d4-b0b4-4c28-aef9-29aca154e059': //Em Analise
      this.isNotPermitirSalvar = true;
      break;
    case 'e91f1439-b00f-4149-95d8-af00a5d52c32': //Aprovado
      this.isNotPermitirSalvar = false;
      this.isPermitirGerarTermo = true;
      this.candidatoService.alterarStatusCandidato({IdCandidato: this.idCandidato, IdStatusCandidato: '917cedf9-bfa5-4a1e-9d42-9c76761a9179'}).subscribe(
        candidato => {
          if(candidato == 'OK'){
            this.gerarTermo();
            //this._router.navigate(['/gerenciar-etapas']);
          }
        },
        error => this.gerenciaErro(error)
      )
      break;
    case 'd7981bec-c4f4-4e11-85e0-eb7338d5cd2d': //Reprovado
      this.confirmationService.confirm({
        message: 'A situação do Candidato ficará como <b>Desclassificado</b> pela Unidade, deseja continuar?',
        header: 'Confirmação',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.candidatoService.alterarStatusCandidato({IdCandidato: this.idCandidato, IdStatusCandidato: 'e8dcab45-91eb-4098-bff6-2f57eaa7a26b'}).subscribe(
            candidato => {
              if(candidato == 'OK'){
                this._router.navigate(['/gerenciar-etapas']);
              }
            },
            error => this.gerenciaErro(error)
          )
        }
      });
      break;
    default:
      break;
  }

}
cancelar() {
  this.confirmationService.confirm({
    message: 'Deseja cancelar?',
    header: 'Confirmação',
    icon: 'fa fa-question-circle',
    accept: () => {
      let arquivosNovos: AbstractControl[];
      arquivosNovos = this.arquivos.controls.filter(
        arquivo => !arquivo.value.isOld
      );
      this._router.navigate(['/gerenciar-etapas']);
    }
  });
}

getTipoArquivo() {
  this.arquivoService
    .getTipoArquivo('Emprego_na_Pista', this.idCandidato)
    .finally(() => (this.isLoading = false))
    .subscribe(
      tipoArquivo => {
        this.tipoArquivo = tipoArquivo;
      },
      error => this.gerenciaErro(error)
    );
}

getTipoAnalise() {
  this.arquivoService
    .getTipoAnalise('Documento_Analise', this.idCandidato)
    .finally(() => (this.isLoading = false))
    .subscribe(
      tipoArquivo => {
        this.tipoAnalise = tipoArquivo;
      },
      error => this.gerenciaErro(error)
    );
}

gerarTermo() {
  this.isLoading = true;
  this.candidatoAprovadoService.gerarTermo(this.idCandidato)
    .finally(() => this.isLoading = false)
    .subscribe(
      data => {
        if (data !== null && data !== '') {
          this.messageService.add({ severity: 'error', summary: 'Atenção', detail: data.toString() });
          return;
        }

        this.candidatoService.downloadTermoAprovado(this.idCandidato);

        setTimeout(
          () => this._router.navigate(['/gerenciar-etapas']),
          2000
        );
      },
      error => this.gerenciaErro(error)
  );
}
}



// WEBPACK FOOTER //
// ./src/app/components/candidato/analisar-documentos-candidato/analisar-documentos-candidato.component.ts